import { render, staticRenderFns } from "./SpotlightResults.vue?vue&type=template&id=5ab8e904"
import script from "./SpotlightResults.vue?vue&type=script&lang=js"
export * from "./SpotlightResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports